<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row">
                        <Loader v-if="isCategoriesFetchPending"
                                class="h-6 w-6 m-2 border-2 -red -sm"/>
                        <template v-else>
                            Categories
                        </template>
                    </span>
                    <LangSwitcher />
                </span>
                <a href="#" @click.prevent="handleCreateCategory"
                   class="flex items-center px-4 py-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                    Créer une categorie
                </a>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <div class="m-4">
                <Search
                    v-model="search"
                    @update:modelValue="handleSearchChange"
                />

                <List
                    :items="categories"
                    :columns="columns"
                    :desc="desc"
                    @sortBy="handleSortBy"
                    @dragEnd="handleDragEnd"
                    @editItem="handleEditCategory"
                    @deleteItem="handleDeleteCategory"
                    moveable
                    editable
                    deletable
                />

                <Pagination
                    v-if="lastPage > 1"
                    :current_project="currentPage"
                    :last_page="lastPage"
                    @change="handleChangePage"
                />
            </div>
        </div>
    </main>
</template>

<script>
    import PageHeader from "../../components/partials/page-header";
    import Loader from "../../components/partials/loader";
    import LangSwitcher from "../../components/partials/lang-switcher";
    import List from "../../components/partials/list"
    import Pagination from "../../components/partials/pagination"
    import Search from "../../components/partials/search"

    export default {
        beforeMount() {
            if (!this.project || this.project.id !== this.$route.params.project_id) {
                this.$store.dispatch('projects/getSingle', {id: this.$route.params.project_id, includes: ['buildings', 'categories', 'status']})
            }
        },
        data() {
            return {
                search: null,
                desc: false
            }
        },
        computed: {
            isCategoriesFetchPending() {
                return this.$store.state.categories.isFetchListPending
            },
            project() {
                return this.$store.state.projects.single;
            },
            categories() {
                return this.project && this.project.categories ? this.project.categories.data : [];
            },
            lastPage() {
                return this.$store.state.categories.pagination.last_page
            },
            currentPage() {
                return this.$store.state.categories.pagination.current_page
            },
            locale() {
                return this.$store.state.config.locale;
            },
            columns() {
                return {
                    id: {},
                    ['translatable.name.' + this.locale]: {
                        sortable: true,
                        sortBy: 'name',
                        label: 'Nom'
                    }
                }
            }
        },
        methods: {
            handleChangePage(page = this.currentPage) {
                this.$store.dispatch('contacts/getList', {
                    'page': page,
                    'sort_by': this.sort_by,
                    'desc': this.desc,
                    'search': this.search ? {'email': this.search} : {}
                });
            },
            handleSortBy(type) {
                this.desc = !this.desc;
                this.sort_by = type;

                this.handleChangePage();
            },
            handleSearchChange(search) {
                this.search = search;
                this.handleChangePage();
            },
            handleCreateCategory() {
                this.$store.dispatch('categories/resetSingle')
                this.$store.dispatch('modals/open', 'category-save');
            },
            handleEditCategory(category) {
                this.$store.dispatch('categories/setSingle', category);
                this.$store.dispatch('modals/open', 'category-save');
            },
            handleDeleteCategory(category) {
                this.$store.state.categories.single = category;
                this.$store.dispatch('modals/open', 'category-delete');
            },
            handleDragEnd(categories) {
                this.$store.dispatch('categories/move', { movedFields: categories });
            }
        },
        components: {
            PageHeader,
            Loader,
            LangSwitcher,
            Search,
            List,
            Pagination
        }
    }
</script>
